// Shared money helpers. Ledger/API units are integer coins (100 coins = $1).
// Convert to dollars ONLY for display; never use floats for balance math.

export const COINS_PER_DOLLAR = 100;

export const coinsToDollars = (coins) => Number(coins || 0) / COINS_PER_DOLLAR;

export const formatUSD = (coins) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(
    coinsToDollars(coins)
  );
